export default {
  props: {
    tag: {
      type: String,
      default: 'span',
    },

    label: {
      type: String,
      default: '',
    },
  },

  render(createElement) {
    const defaultSlot = this.$slots.default ? this.$slots.default : this.label

    return createElement(
      this.tag,
      {
        attrs: {
          class: ['title'],
        },
      },
      defaultSlot
    )
  },
}
